module.exports = __webpack_public_path__ + "static/media/rescheduling_needed.9cf96878.svg";